import { render, staticRenderFns } from "./DocumentationPage.vue?vue&type=template&id=66ce095c&scoped=true&"
import script from "./DocumentationPage.vue?vue&type=script&lang=js&"
export * from "./DocumentationPage.vue?vue&type=script&lang=js&"
import style0 from "./DocumentationPage.vue?vue&type=style&index=0&id=66ce095c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ce095c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\DigitalCreditTransfer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ce095c')) {
      api.createRecord('66ce095c', component.options)
    } else {
      api.reload('66ce095c', component.options)
    }
    module.hot.accept("./DocumentationPage.vue?vue&type=template&id=66ce095c&scoped=true&", function () {
      api.rerender('66ce095c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/DocumentationPage.vue"
export default component.exports